import { getImage } from "./utils";
import { WASM_TEXTURES } from "./const";
import { CONFIG } from "~/config";

export default class WasmTextures {
	#scale: number;

	#image: HTMLImageElement;

	#canvas: HTMLCanvasElement;

	#ctx: CanvasRenderingContext2D;

	constructor(scale: number) {
		this.#scale = scale;
		this.#image = null;
		this.#canvas = document.createElement("canvas");
		this.#ctx = this.#canvas.getContext("2d", { willReadFrequently: true });
	}

	async load() {
		const image = await getImage(`/img/wasm-textures/wasm-textures-${this.#scale}x.png?version=${CONFIG.version}`);

		this.#image = image;

		if (this.#image) {
			this.#canvas.width = this.#image.naturalWidth;
			this.#canvas.height = this.#image.naturalHeight;
			this.#ctx.drawImage(this.#image, 0, 0);
		} else {
			this.#canvas.width = WASM_TEXTURES.defSize;
			this.#canvas.height = WASM_TEXTURES.defSize;
			this.#ctx.fillStyle = "red";
			this.#ctx.fillRect(0, 0, WASM_TEXTURES.defSize, WASM_TEXTURES.defSize);
		}
	}

	get image() {
		return this.#image;
	}

	get ctx() {
		return this.#ctx;
	}

	get scale() {
		return this.#scale;
	}
}
